const routes = [
  {
    path: '*',
    redirect: '/sv',
  },
  {
    path: '/:language',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: {
      sitemap: true,
      prerender: true
    }
  },
  {
    path: '/:language/products',
    name: 'products',
    component: () => import('@/views/Products.vue'),
    props: (route: any) => (
      {
        query: {
          searchText: route.query.searchText,
          tagIds: route.query.tagIds ? route.query.tagIds.split(',') : []
      }
    }),
    meta: {
      sitemap: true,
      prerender: true
    },
    children: [
      {
        path: ':productId',
        name: 'product',
        props: true,
        component: () => import('@/components/Product.vue')
      }
    ]
  },
  {
    path: '/:language/shop',
    name: 'shop',
    component: () => import('@/views/Shop.vue'),
    props: (route: any) => (
      {
        query: {
          searchText: route.query.searchText,
          tagIds: route.query.tagIds ? route.query.tagIds.split(',') : []
      }
    }),
    meta: {
      sitemap: true,
      prerender: true
    },
    children: [
      {
        path: ':itemId',
        name: 'item',
        props: true,
        component: () => import('@/components/Item.vue')
      }
    ]
  },
  {
    path: '/:language/characters',
    name: 'characters',
    component: () => import('@/views/Characters.vue'),
    meta: {
      sitemap: true,
      prerender: true
    },
    children: [
      {
        path: ':characterId',
        name: 'character',
        props: true,
        component: () => import('@/components/Character.vue')
      }
    ]
  },
  {
    path: '/:language/cart',
    name: 'cart',
    component: () => import('@/views/ShoppingCart.vue'),
    meta: {
      prerender: true
    }
  },
  {
    path: '/:language/collection',
    name: 'collection',
    component: () => import('@/views/Collection.vue'),
    meta: {
      sitemap: true,
      prerender: true
    }
  },
  {
    path: '/:language/collection/:collectionId',
    name: 'sharedCollection',
    props: true,
    component: () => import('@/views/Collection.vue')
  },
  {
    path: '/:language/likes',
    name: 'likes',
    component: () => import('@/views/Likes.vue'),
    meta: {
      prerender: true
    }
  },
  {
    path: '/:language/signin',
    name: 'signin',
    component: () => import('@/views/SignIn.vue'),
    meta: {
      sitemap: true,
      prerender: true
    }
  },
  {
    path: '/:language/signup',
    name: 'signup',
    component: () => import('@/views/SignUp.vue'),
    meta: {
      sitemap: true,
      prerender: true
    }
  },
  {
    path: '/:language/admin',
    name: 'admin',
    component: () => import('@/views/Admin.vue'),
    redirect: { name: 'admin-products' },
    meta: {
      admin: true
    },
    children: [
      {
        path: '/:language/admin/products/:productId?',
        name: 'admin-products',
        props: true,
        component: () => import('@/components/ProductEditor.vue'),
        meta: {
          admin: true
        }
      },
      {
        path: '/:language/admin/items/:itemId?',
        name: 'admin-items',
        props: true,
        component: () => import('@/components/ItemEditor.vue'),
        meta: {
          admin: true
        }
      },
      {
        path: '/:language/admin/characters/:characterId?',
        name: 'admin-characters',
        props: true,
        component: () => import('@/components/CharacterEditor.vue'),
        meta: {
          admin: true
        }
      },
      {
        path: '/:language/admin/tags',
        name: 'admin-tags',
        component: () => import('@/components/TagEditor.vue'),
        meta: {
          admin: true
        }
      },
      {
        path: '/:language/admin/shippings',
        name: 'admin-shippings',
        component: () => import('@/components/ShippingEditor.vue'),
        meta: {
          admin: true
        }
      },
      {
        path: '/:language/admin/payings',
        name: 'admin-payings',
        component: () => import('@/components/PayingEditor.vue'),
        meta: {
          admin: true
        }
      },
      {
        path: '/:language/admin/coupons',
        name: 'admin-coupons',
        component: () => import('@/components/CouponEditor.vue'),
        meta: {
          admin: true
        }
      },
      {
        path: '/:language/admin/orders',
        name: 'admin-orders',
        component: () => import('@/components/OrderEditor.vue'),
        meta: {
          admin: true
        }
      },
      {
        path: '/:language/admin/accounting',
        name: 'admin-accounting',
        component: () => import('@/components/Accounting.vue'),
        meta: {
          admin: true
        }
      },
      {
        path: '/:language/admin/users',
        name: 'admin-users',
        component: () => import('@/components/UserList.vue'),
        meta: {
          admin: true
        }
      }
    ]
  },
  {
    path: '/:language/mypage',
    name: 'mypage',
    component: () => import('@/views/MyPage.vue'),
    meta: {
      prerender: true,
      loggedIn: true
    }
  },
  {
    path: '/:language/orders',
    name: 'orders',
    component: () => import('@/views/Orders.vue'),
    meta: {
      prerender: true,
      loggedIn: true
    }
  },
  {
    path: '/:language/validate',
    name: 'validate',
    component: () => import('@/views/Validate.vue'),
    meta: {
      prerender: true
    }
  },
  {
    path: '/:language/signin/reset',
    name: 'reset',
    component: () => import('@/views/ResetPassword.vue'),
    meta: {
      prerender: true
    }
  },
  {
    path: '/:language/signin/reset/:resetPasswordId',
    name: 'set',
    props: true,
    component: () => import('@/views/NewPassword.vue')
  },
  {
    path: '/:language/validate/:validationCode',
    name: 'validateWithId',
    props: true,
    component: () => import('@/views/Validate.vue')
  },
  {
    path: '/:language/info*',
    name: 'info',
    component: () => import('@/views/Information.vue')
  },
  {
    path: '/:language/faq',
    name: 'faq',
    component: () => import('@/views/FrequentlyAskedQuestions.vue')
  }
];

export default routes;
